<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
		<path d="M 6 6 L 18 18 M 18 6 L 6 18" stroke="currentColor" />
		<circle cx="12" cy="12" r="11" stroke="currentColor" class="hidden sm:block" />
	</svg>
</div>
